import React, { useEffect, useState } from "react";
import { Routes, Route, NavLink } from "react-router-dom";

import Ambassadorclub from "./pages/AmbassadorClub";
import Home from "./pages/Home";
import Events from "./pages/Events";
import EventRegistration from "./pages/EventRegistration";
import SlamFestInfo from "./pages/SlamFestInfo";
import EventsWithSchools from "./pages/eventswithschools";
import AmbassadorClubRegister from "./pages/AmbassadorClubRegister";
import CookiesPolicy from "./pages/CookiesPolicy";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import RefundPolicy from "./pages/RefundPolicy";
import TermsConditions from "./pages/TermsConditions";
import Footer from "./components/Footer";

import "./App.css";

export default function App() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-gray-100">
      {/* Header */}
      <header
        className={`flex justify-between items-center p-5 bg-blue-700 text-white fixed w-full top-0 z-50 transition-shadow duration-300 border-b-4 border-white ${
          scrolled ? "shadow-xl" : "shadow-none"
        }`}
      >
        <img src="/LOGO ESMAAASH black.png" alt="Logo" className="h-12" />

      <nav className="ml-auto flex items-center flex-nowrap gap-2 bg-black px-4 py-2 rounded-xl shadow-md overflow-x-auto">
  <NavLink
    to="/"
    end
    className={({ isActive }) =>
      isActive
        ? "tab-active"
        : "tab-default"
    }
  >
    Home
  </NavLink>

  <NavLink
    to="/Events"
    className={({ isActive }) =>
      isActive
        ? "tab-active"
        : "tab-default"
    }
  >
    Events
  </NavLink>

  <NavLink
    to="/Ambassadorclub"
    className={({ isActive }) =>
      isActive
        ? "tab-active"
        : "tab-default"
    }
  >
    Ambassador Club
  </NavLink>
</nav>

      </header>

      {/* Body content with padding to avoid header overlap */}
      <div className="pt-24">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/Events" element={<Events />} />
          <Route path="/Ambassadorclub" element={<Ambassadorclub />} />
          <Route path="/SlamFestInfo" element={<SlamFestInfo />} />
          <Route path="/eventswithschools" element={<EventsWithSchools />} />
          <Route path="/register/:event_id" element={<EventRegistration />} />
          <Route
            path="/AmbassadorClubRegister"
            element={<AmbassadorClubRegister />}
          />
          <Route path="/CookiesPolicy" element={<CookiesPolicy />} />
          <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
          <Route path="/RefundPolicy" element={<RefundPolicy />} />
          <Route path="/TermsConditions" element={<TermsConditions />} />
        </Routes>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
}
